import ConfigApi from '@/api/config/_api_config'
import Api from '@/api/api'

const options = token => ({ med_access_scoped: true, headers: { 'X-Prescripteurs-Access': token } })
export default {
    async access() {
        return (await ConfigApi().post('/prescripteurs/access', {}, { prescripteurs_scoped: true })).data.data.access_token
    },
    async catalogue(token) { return (await Api().get('/prescripteurs/prestations', options(token))).data.data },
    async activation(token) { return (await Api().get('/prescripteurs/activation', options(token))).data.data },
    async activer(active, token) { return (await Api().put('/prescripteurs/activation', { active }, options(token))).data.data },
    async liste(params, token) { return (await Api().get('/prescripteurs', Object.assign(options(token), { params }))).data },
    async enregistrer(draft, token) {
        const api = Api(), response = draft.id
            ? await api.put('/prescripteurs/' + draft.id, draft, options(token))
            : await api.post('/prescripteurs', draft, options(token))
        return response.data.data
    }
}
